<template>
  <div id="app-header" v-show="showHeader">
    <v-toolbar class="first-toolbar px" height="unset" flat elevation="2">
      <a href="/">
        <v-toolbar-title class="d-flex align-center link primary--text">
          <img class="app-logo" src="@/assets/logo.png" />
          <span class="hidden-md-and-up" v-html="$t('headerTitleShort')"></span>
          <span class="hidden-sm-and-down" v-html="$t('headerTitle')"></span>
        </v-toolbar-title>
      </a>
      <v-spacer />
      <AppContacts class="ml-5 hidden-sm-and-down" />
      <AppHeaderActions small class="d-flex align-center justify-end d-md-none">
        <v-btn @click="switchNavigation(true)" small color="primary" icon>
          <v-icon>menu</v-icon>
        </v-btn>
      </AppHeaderActions>
    </v-toolbar>
    <v-toolbar
      class="second-toolbar hidden-sm-and-down"
      height="unset"
      color="primary"
      elevation="2"
      v-show="showNavigation"
    >
      <template v-for="(navigationItem, navigationIndex) in navigationItems">
        <NavigationMenu
          :key="navigationIndex"
          v-if="navigationItem.children && navigationItem.children.length"
          :text="navigationItem.text"
          :items="navigationItem.children"
        />
        <router-link
          :key="navigationIndex"
          v-else-if="navigationItem.to"
          :to="navigationItem.to"
          class="navigation-item"
          :class="{ 'inner-link': navigationItem.children }"
          >{{ $t(navigationItem.text) }}
        </router-link>
        <a
          :key="navigationIndex"
          v-else-if="navigationItem.href"
          class="navigation-item"
          :href="navigationItem.href"
          target="_blank"
          >{{ $t(navigationItem.text) }}</a
        >
      </template>

      <AppHeaderActions
        class="justify-end"
        style="
          position: absolute;
          top: 0;
          right: 100px;
          height: 60px;
          width: 150px;
        "
      />
    </v-toolbar>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import NavigationMenu from "../ui/NavigationMenu.vue";

import AppContacts from "../ui/AppContacts.vue";
import AppHeaderActions from "../ui/AppHeaderActions.vue";
import baseModule from "@/store/base.module";

@Component({
  components: {
    NavigationMenu,
    AppContacts,
    AppHeaderActions,
  },
  methods: { switchNavigation: baseModule.switchNavigation },
})
export default class extends Vue {
  get navigationItems() {
    return baseModule.navigationItems;
  }
  get showHeader() {
    return baseModule.showHeader;
  }
  get showNavigation() {
    return baseModule.showNavigation;
  }
}
</script>
<style lang="scss">
@import "~vuetify/src/styles/styles.sass";

#app-header {
  .link {
    font-size: 16px !important;
    line-height: 19px !important;
    white-space: nowrap;
  }

  .navigation-item {
    color: white !important;
  }

  .navigation-item.router-link-exact-active::after,
  .navigation-item.inner-link.router-link-active::after,
  .navigation-item:hover::after {
    background: white;
  }
}
.app-logo {
  float: left;
  width: 96px;
}

.first-toolbar .v-toolbar__content {
  padding-left: 0px;
  padding-right: 0px;
}
.second-toolbar .v-toolbar__content {
  flex-wrap: wrap;
  padding: 0px 100px;
  padding-right: 250px;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .app-logo {
    width: 47px;
  }
}
</style>
